import { render, staticRenderFns } from "./phone-number-item.vue?vue&type=template&id=738ef4bf&scoped=true"
import script from "./phone-number-item.vue?vue&type=script&lang=js"
export * from "./phone-number-item.vue?vue&type=script&lang=js"
import style0 from "./phone-number-item.vue?vue&type=style&index=0&id=738ef4bf&prod&scoped=true&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "738ef4bf",
  null
  
)

export default component.exports